// extracted by mini-css-extract-plugin
export default {"loading":"location_loading-text_loading","gray":"location_loading-text_gray"};